<router-outlet></router-outlet>
<div class="example-loading-shade loading-view" *ngIf="loadingView">
    <mat-spinner ></mat-spinner>
</div>